import React, { useCallback, useMemo, useState } from 'react'
import Modal from 'react-modal'
import Loading from 'components/Loading'
import { BlockUiContext, BlockUiActions } from 'components/BlockUi/context'

export { BlockUiContext } from 'components/BlockUi/context'

type WithBlockUI = <T>(callback: () => Promise<T>) => Promise<T>

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '20px',
    borderWidth: 0,
    borderRadius: '10px'
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.53)',
    zIndex: 1000
  }
}

function BlockUiLoader() {
  return (
    <Modal contentLabel="Loading..." style={modalStyles} isOpen>
      <div>
        <Loading />
      </div>
    </Modal>
  )
}

export const BlockUiProvider: React.FC<{ children?: React.ReactNode }> = ({
  children
}) => {
  const [open, setOpen] = useState<number>(0)
  const startBlockUi = useCallback(() => setOpen((s) => s + 1), [setOpen])
  const stopBlockUi = useCallback(() => setOpen((s) => s - 1), [setOpen])

  const value = useMemo<BlockUiActions>(() => {
    const withBlockUi: WithBlockUI = async (callback) => {
      try {
        startBlockUi()
        return await callback()
      } finally {
        stopBlockUi()
      }
    }
    return {
      startBlockUi,
      stopBlockUi,
      withBlockUi
    }
  }, [startBlockUi, stopBlockUi])
  return (
    <BlockUiContext.Provider value={value}>
      {children}
      {open > 0 && <BlockUiLoader />}
    </BlockUiContext.Provider>
  )
}
